import axios from "axios";

export const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
});

export const backendBaseUrl = process.env.REACT_APP_BASE_URL_BACKEND;
